import { consoleEvents, LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import { OffersProps } from './types'

const fetchRewardsStart = (state): any => ({
  ...state,
  rewardsLoadingState: LoadingStates.Loading,
})

const fetchRewardsSuccess = (state, rewards): any => ({
  ...state,
  rewards,
  rewardsLoadingState: LoadingStates.LoadedSuccess,
  wasRewardsResponseEmpty: rewards.length === 0,
  vouchers: rewards.filter((item) => item.isOfferOrVoucher === 'voucher'),
  offers: rewards.filter((item) => item.isOfferOrVoucher === 'offer'),
})

const fetchRewardsFail = (state, error): any => {
  consoleEvents.error(`Failed to load rewards:`, error)

  return {
    ...state,
    rewardsLoadingState: LoadingStates.LoadedFail,
  }
}
const fetchRewardDetailStart = (state): any => ({
  ...state,
  rewardDetailLoadingState: LoadingStates.Loading,
  promotionCode: '',
})

const fetchRewardDetailSuccess = (state, rewardDetail): any => ({
  ...state,
  rewardDetail,
  rewardDetailLoadingState: LoadingStates.LoadedSuccess,
})

const fetchRewardDetailFail = (state, error): any => {
  consoleEvents.error(`Failed to load reward details`, error)

  return {
    ...state,
    rewardDetail: {},
    rewardDetailLoadingState: LoadingStates.LoadedFail,
  }
}

const redeemOfferStart = (state): any => ({
  ...state,
  redeemOfferLoadingState: LoadingStates.Loading,
  addOfferToBagErrorMessage: '',
})

const redeemOfferSuccess = ({ rewards, ...state }, offer): any => {
  const index = rewards.findIndex(
    (reward) => reward.offerPropositionId === offer.offerPropositionId,
  )
  rewards[index].isOfferActive = true
  rewards[index].activeOfferExpiresAt = offer.activeOfferExpiresAt
  return {
    ...state,
    redeemOfferLoadingState: LoadingStates.LoadedSuccess,
    rewards,
  }
}
const redeemOfferFail = (state, error): any => {
  consoleEvents.error(`Failed to redeem offer`, error)

  return {
    ...state,
    redeemOfferLoadingState: LoadingStates.LoadedFail,
  }
}

const cancelActiveOffer = ({ rewards, ...state }, offerPropositionId): any => {
  const index = rewards.findIndex((reward) => reward.offerPropositionId === offerPropositionId)
  rewards[index].activeOfferExpiresAt = Date.now()
  return {
    ...state,
    rewards,
  }
}

const addOfferToBagStart = (state): any => ({
  ...state,
  addOfferToBagLoadingState: LoadingStates.Loading,
  addOfferToBagErrorMessage: '',
})

const addOfferToBagSuccess = (state): any => ({
  ...state,
  addOfferToBagLoadingState: LoadingStates.LoadedSuccess,
})

const addOfferToBagFail = (state, errorMessage): any => ({
  ...state,
  addOfferToBagLoadingState: LoadingStates.LoadedFail,
  addOfferToBagErrorMessage: errorMessage,
})

const fetchPromotionCodeStart = (state): any => ({
  ...state,
  promotionCodeLoadingState: LoadingStates.Loading,
  promotionCodeErrorMessage: '',
})

const fetchPromotionCodeSuccess = (state, promotionCode): any => ({
  ...state,
  promotionCodeLoadingState: LoadingStates.LoadedSuccess,
  promotionCode,
})

const fetchPromotionCodeFail = (state, errorMessage): any => ({
  ...state,
  promotionCodeLoadingState: LoadingStates.LoadedFail,
  promotionCodeErrorMessage: errorMessage,
})

const resetPromotionCodeState = (state): OffersProps => ({
  ...state,
  promotionCodeLoadingState: LoadingStates.NotLoaded,
})

const setSelectedTab = (state: OffersProps, tab: string): OffersProps => ({
  ...state,
  selectedTab: tab,
})
const reducer = createReducer((on) => {
  on(actions.fetchRewardsStart, fetchRewardsStart)
  on(actions.fetchRewardsSuccess, fetchRewardsSuccess)
  on(actions.fetchRewardsFail, fetchRewardsFail)
  on(actions.fetchRewardDetailStart, fetchRewardDetailStart)
  on(actions.fetchRewardDetailSuccess, fetchRewardDetailSuccess)
  on(actions.fetchRewardDetailFail, fetchRewardDetailFail)
  on(actions.redeemOfferStart, redeemOfferStart)
  on(actions.redeemOfferSuccess, redeemOfferSuccess)
  on(actions.redeemOfferFail, redeemOfferFail)
  on(actions.cancelActiveOffer, cancelActiveOffer)
  on(actions.addOfferToBagStart, addOfferToBagStart)
  on(actions.addOfferToBagSuccess, addOfferToBagSuccess)
  on(actions.addOfferToBagFail, addOfferToBagFail)
  on(actions.fetchPromotionCodeStart, fetchPromotionCodeStart)
  on(actions.fetchPromotionCodeSuccess, fetchPromotionCodeSuccess)
  on(actions.fetchPromotionCodeFail, fetchPromotionCodeFail)
  on(actions.resetPromotionCodeState, resetPromotionCodeState)
  on(actions.setSelectedTab, setSelectedTab)
}, initialState)

export default reducer
